import { useTranslation } from "react-i18next";

const BrandCarousel = () => {
  const { t } = useTranslation();
  const brands = [
    { id: 1, name: t("brand_1"), logo: "/slide1.webp" },
    { id: 2, name: t("brand_2"), logo: "/slide2.webp" },
    { id: 3, name: t("brand_3"), logo: "/slide3.webp" },
    { id: 4, name: t("brand_4"), logo: "/slide4.webp" },
    { id: 5, name: t("brand_5"), logo: "/slide5.webp" },
    { id: 6, name: t("brand_6"), logo: "/slide6.webp" },
    { id: 7, name: t("brand_7"), logo: "/slide7.webp" },
    { id: 8, name: t("brand_8"), logo: "/slide8.webp" },
    { id: 9, name: t("brand_9"), logo: "/slide9.webp" },
    { id: 10, name: t("brand_10"), logo: "/slide10.webp" },
    { id: 11, name: t("brand_11"), logo: "/slide11.webp" },
    { id: 12, name: t("brand_12"), logo: "/slide12.webp" },
    { id: 13, name: t("brand_13"), logo: "/slide13.webp" },
  ];

  return (
    <div className="bg-white py-16 overflow-hidden">
      <div className="flex w-max animate-scroll gap-16">
        {[...brands, ...brands].map((brand, index) => (
          <div key={index} className="flex-shrink-0  hover:grayscale-0 transition duration-300">
            <img
              src={brand.logo}
              alt={brand.name}
              className="h-16 lg:h-20 md:h-16 sm:h-12 w-auto object-contain"
              loading="lazy"
            />
          </div>
        ))}
      </div>

      <style>{`
        @keyframes scroll {
          from {
            transform: translateX(0);
          }
          to {
            transform: translateX(-50%);
          }
        }

        .animate-scroll {
          animation: scroll 20s linear infinite;
        }

        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
};

export default BrandCarousel;